import defaultApi from '@/utils/request';

export default {
  // ---------------------- S1CW4001 --------------------------------------
  // 加載列表
  S14W2001_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S05/S14/S14W2001_Load',
      params,
    });
  },
  S14W2001_LoadProxyUnit(params) {
    return defaultApi({
      method: 'get',
      url: 'S05/S14/S14W2001_LoadProxyUnit',
      params,
    });
  },
  S14W2001_LoadEmployee(params) {
    return defaultApi({
      method: 'get',
      url: 'S05/S14/S14W2001_LoadEmployee',
      params,
    });
  },
  S14W2001_ApplyOne(params) {
    return defaultApi({
      method: 'get',
      url: 'S05/S14/S14W2001_ApplyOne',
      params,
    });
  },
  S14W2001_Approve_cancel(data) {
    return defaultApi({
      method: 'post',
      url: 'S05/S14/S14W2001_Approve_cancel',
      data,
    });
  },
  S14W2001_Approve_delete(data) {
    return defaultApi({
      method: 'post',
      url: 'S05/S14/S14W2001_Approve_delete',
      data,
    });
  },
  S14W2001_SaveApply(data) {
    return defaultApi({
      method: 'post',
      url: 'S05/S14/S14W2001_SaveApply',
      data,
    });
  },
  S14W2001_Approve(data) {
    return defaultApi({
      method: 'post',
      url: 'S05/S14/S14W2001_Approve',
      data,
    });
  },
  S14W2001_ApproveResend(data) {
    return defaultApi({
      method: 'post',
      url: 'S05/S14/S14W2001_ApproveResend',
      data,
    });
  },
  S14W2001_LoadDetail(params) {
    return defaultApi({
      method: 'get',
      url: 'S05/S14/S14W2001_LoadDetail',
      params,
    });
  },
  S14W2001_LoadEmpupd(params) {
    return defaultApi({
      method: 'get',
      url: 'S05/S14/S14W2001_LoadEmpupd',
      params,
    });
  },
  S14W2001_LeaveAttachmentViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S05/S14/S14W2001_LeaveAttachmentViewLoad',
      params,
    });
  },
  S14W2001_LeaveAttachmentViewFileUpload(data) {
    return defaultApi({
      method: 'post',
      url: 'S05/S14/S14W2001_LeaveAttachmentViewFileUpload',
      data,
    });
  },
  S14W2001_LeaveAttachmentViewFileDelete(data) {
    return defaultApi({
      method: 'post',
      url: 'S05/S14/S14W2001_LeaveAttachmentViewFileDelete',
      data,
    });
  },

  // -----------------------------------------------------------------------------
};
